import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { HostedTrackingConfig, AdConfig } from "../../ts-interfaces/hosted-tracking-config";
import { OrderInterface } from "../../ts-interfaces/order-interface";
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'; // dependent on utc plugin
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import { SharedService } from 'src/app/services/shared.service';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

@Component({
  selector: 'ds-delivery-order-details',
  templateUrl: './delivery-order-details.component.html',
  styleUrls: ['./delivery-order-details.component.scss']
})
export class DeliveryOrderDetailsComponent implements OnInit, OnChanges {
  @Input() order!: OrderInterface;
  @Input() hostedTrackingConfig!: HostedTrackingConfig;
  @Input() isSystemStatus!: boolean;
  @Input() showSiblingOrders!: boolean;
  @Input() isNegativeStatus!: boolean;
  @Output() openDeliveryProofsModal: EventEmitter<boolean> = new EventEmitter();
  public primaryAds: AdConfig | undefined;
  public unavalailableOrderHeader: string = "";
  public unavalailableOrderBody: string = "";

  constructor(
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.primaryAds = this.hostedTrackingConfig.components.ads.find(ads => {
      return ads.active && ads.type === "primary";
    });
    this.updateUnavailableOrderMessages();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['order']) {
      this.updateUnavailableOrderMessages();
    }
  }

  updateUnavailableOrderMessages(): void {
    this.unavalailableOrderHeader = this.getOrderUnavailableHeader();
    this.unavalailableOrderBody = this.getOrderUnavailableBody();
  }

  getOrderUnavailableHeader() {
    const experienceType = (this.order?.orderAttributes?.experienceType || this.order?.type || "") as string;
    const status = this.order?.status;
    return status ? this.sharedService.getTranslatedStatus(experienceType, status, "HEADER") : "";
  }

  getOrderUnavailableBody() {
    const experienceType = (this.order?.orderAttributes?.experienceType || this.order?.type || "") as string;
    const status = this.order?.status;
    return status ? this.sharedService.getTranslatedStatus(experienceType, status, "BODY") : "";
  }
}
